import gql from 'graphql-tag';

const CREATE_SALESFORCE_OPPORTUNITY_CONTACT_ROLE = gql`
  mutation CreateSalesforceOpportunityContactRole(
    $opportunityId: String!
    $contactId: String!
    $roleName: String!
    $isPrimary: Boolean!
  ) {
    createSalesforceOpportunityContactRole(
      opportunityId: $opportunityId
      contactId: $contactId
      roleName: $roleName
      isPrimary: $isPrimary
    )
  }
`;

export default CREATE_SALESFORCE_OPPORTUNITY_CONTACT_ROLE;
